import EllipsisTooltip from '@mindtickle/ellipsis-tooltip';
import { TEXT_COLORS, TEXT_TYPES } from '@mindtickle/styles/lib/classNames';

import { UserInfo } from '../../type';
import { StyledProfileDetailWrapper } from './style';

type ProfileDetailProps = {
  user: UserInfo;
  customViewProfileNode?: React.ReactNode;
};

const ProfileDetail = ({ user: { name }, customViewProfileNode }: ProfileDetailProps) => (
  <StyledProfileDetailWrapper data-testid={'header-profile-section'}>
    <EllipsisTooltip
      title={name}
      wrapperClassName={`profile-user-name-ellipsis ${TEXT_TYPES.HEADING_SMALL} ${TEXT_COLORS.DEFAULT}`}
    >
      {name}
    </EllipsisTooltip>
    {customViewProfileNode}
  </StyledProfileDetailWrapper>
);

export default ProfileDetail;
